import React from 'react';
export default function LinkedLearningDescription({text}) {
 const path='(?:notes/[0-9a-f-]{36}/entries/[0-9a-f-]{36}|learning/program/program-[0-9a-f-]{36}(?:\\?note=[0-9a-f-]{36})?)';
 const url='https://home\\.awmgo\\.com/'+path;
 const pattern=new RegExp('\\[([^\\]\\n]+)\\]\\(('+url+')\\)|('+url+')','gi');
 const source=String(text||''),parts=[];let offset=0;
 for(const match of source.matchAll(pattern)){
  parts.push(source.slice(offset,match.index));const href=match[2]||match[3];
  parts.push(<a key={match.index} href={href}>{match[1]||(href.includes('/notes/')?'Lab Status Check':'Open program')}</a>);offset=match.index+match[0].length;
 }
 parts.push(source.slice(offset));return <p style={{whiteSpace:'pre-wrap'}}>{parts}</p>;
}
